import { Component, inject, ChangeDetectionStrategy, OnInit, OnDestroy, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import {
  LoggerService,
  RisrList,
  RisrListView,
  RisrSlotCard,
  SlotCardTitle,
  RisrHeaderCardTitle,
  RisrHeaderCard,
  SlotCardActions,
  ListOptions } from '@fry-it/risr-core';
import { ReportStore } from '../../services/report-store';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { SearchReport } from '../../models/search_report';

@Component({
  selector: 'risr-reports-list',
  standalone: true,
  imports: [
    RouterLink,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    RisrListView,
    RisrSlotCard,
    SlotCardTitle,
    RisrHeaderCardTitle,
    RisrHeaderCard,
    SlotCardActions,
  ],
  templateUrl: './reports-list.html',
  styleUrls: ['./reports-list.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    RisrList
  ]
})
export class ReportsList implements OnInit, OnDestroy {


  private list = inject<RisrList<SearchReport>>(RisrList);
  private logger = inject(LoggerService).scope('ReportsList');
  private reportStore = inject(ReportStore);
  private route = inject(ActivatedRoute);
  remoteUser = toSignal(this.route.paramMap.pipe(map(params => params.get('user'))));

  fixedFilter = computed(() => ({
    purpose: 'mixed',
    run_for: this.remoteUser() || '__own__'
  }));

  protected listResource = this.list.resource;

  async ngOnInit() {
    const options: ListOptions = {
      fixedFilter: this.fixedFilter(),
      featuredFilters: ["text"],
      allowedFilters: ["text"]
    };
    this.list.init(this.reportStore.searchSource, options);
  }

  ngOnDestroy() {
    this.logger.info('Destroying ReportsList');
    this.list.destroy();
  }
}
